import PageContainer from '../layout/PageContainer';

export default function NotFound() {
  return <PageContainer
    title="Not Found"
  >
  </PageContainer>
}
